<template>
	<AccountForgot />
</template>

<script setup>
import {
	COMPANY_NAME,
	BASE_URL
} from '@/constants/index.js'

const { t } = useI18n({
	useScope: 'global'
})

useHead({
	title: t('forgot-password.meta-title'),
	meta: [
		{ name: 'description', content: t('forgot-password.meta-description', { COMPANY_NAME }) },
		{ name: 'url', content: BASE_URL }
	],
	link: [
		{
			rel: 'icon',
			type: 'image/x-icon',
			href: '/favicon.ico'
		}
	]
})
</script>
